import { useQuery } from "@tanstack/react-query";
import { useAuth } from "../../../Context/AuthContext";
import { getRCSByPartner } from "../api/RCSDashboardApi";

export const useRCSByPartner = () => {
  const auth = useAuth();
  const user = auth.getSessionData();

  return useQuery({
    queryKey: ["RCSDashboardPartner"],
    queryFn: async () => {
      return await getRCSByPartner({ token: user.token });
    },
    initialData: [],
    refetchOnWindowFocus: false,
  });
};
